export default __webpack_public_path__ + "static/media/Moderat - A New Error.0d928a83.mp3";